import { inject, Injectable, signal } from '@angular/core';
import { CommonHttpService } from '../../common-http.service';
import { IAuctionListing } from '../../../models/IAuctionListing';
import { catchError, from, Observable, single, switchMap, tap, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable({
  providedIn: 'root'
})
export class AuctionListingService {

  constructor() { }

  private httpService = inject(CommonHttpService)
  private readonly oidcSecurityService = inject(OidcSecurityService);
  auctionListingSignal = signal<IAuctionListing[] | null>([])
  causesSignal = signal<string[] | null>([])

  isLoading = signal(false);



  public getAuctionListing(filters: { category?: string; country?: string | null, state?: string | null; }): Observable<IAuctionListing[]> {

    let url = `${environment.apiUrl}/v3/bidder-community/auctions/browse/${filters.category}`;

    let params = new URLSearchParams();

    // Add parameters only if they exist

    if (filters.country) params.append('country', filters.country.toString());
    if (filters.state) params.append('state', filters.state.toString());

    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    // console.log(url);

    this.isLoading.set(true);

    return from(this.oidcSecurityService.checkAuth()).pipe(
      switchMap(authResult => {
        if (authResult.isAuthenticated) {
          const headers = new HttpHeaders()
            .set('Authorization', `Bearer ${authResult.accessToken}`)
            .set('Content-Type', 'application/x-www-form-urlencoded')
            .set('Accept', 'application/json');

          return this.httpService.get<IAuctionListing[]>(url, undefined, headers);
        } else {
          return this.httpService.get<IAuctionListing[]>(url);
        }
      }),
      tap(response => {
        this.auctionListingSignal.set(response);
        this.isLoading.set(false);

        // console.log('response auction listing', response);
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg = typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    );

  }

  public getCauses(): Observable<string[]> {

    const url = `${environment.apiUrl}/v3/bidder-community/auctions/causes`;

    return this.httpService.get<string[]>(url).pipe(
      tap(response => {
        this.causesSignal.set(response);
        // console.log('response causes', response);
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg = typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    );

  }



}
